import { useLang } from "../i18n/LanguageContext";

export default function TextMarqueeBand() {
  const { t } = useLang();
  const items = Array.from({ length: 6 }).map(() => t.marquee).join("");
  return (
    <section
      data-testid="text-marquee-band"
      className="relative border-y border-[#1a1a1a] py-8 md:py-12 overflow-hidden"
    >
      <div className="marquee-mask">
        <div className="text-marquee font-serif italic text-5xl md:text-7xl lg:text-8xl tracking-tight whitespace-nowrap">
          <span className="text-white">{items}</span>
          <span className="text-[#ff4500]">{items}</span>
        </div>
      </div>
    </section>
  );
}
